import config from '../../../../../config';
import {authFetch, checkStatus} from '../../../../utils/http';
import {getURIEncodedTimeZone} from '../../../../utils/datetime';
import {INVITATION_API as NETWORK_INVITATION_API} from '../network/LiveNetworkEnrollmentService';
import {INVITATION_API as PROJECT_INVITATION_API} from '../project/LiveProjectEnrollmentService';
import {convertTokenFromAPI} from '../../helper';

const INVITATION_API = `${config.enrollmentApi}/api/v1/invitations`;

function decodeToken(token) {
  return fetch(`${INVITATION_API}/${token}`)
    .then(checkStatus)
    .then(response => response.json())
    .then(response => convertTokenFromAPI(response));
}

function createAccessCode(organisationSourceId, invitation) {
  return authFetch(`${INVITATION_API}/${organisationSourceId}/clients/accessCode`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(invitation)
  })
    .then(checkStatus)
    .then(response => response.json());
}

function downloadAccessCode(organisationSourceId, invitationId) {
  return `${INVITATION_API}/${organisationSourceId}/clients/accessCode?invitationId=${invitationId}&timeZone=${getURIEncodedTimeZone()}`;
}

function addSubcontractorViaAccessCode(organisationId, accessCode) {
  return authFetch(`${INVITATION_API}/${organisationId}/accessCode`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({accessCode})
  })
    .then(checkStatus);
}

function inviteUser(userInvitation) {
  return authFetch(`${config.enrollmentApi}/api/v1/inviteUser`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(userInvitation)
  })
    .then(checkStatus);
}

function getPendingInvitationExistsRequest(api) {
  return invitationId => fetch(`${api}/${invitationId}/pending`)
    .then(checkStatus)
    .then(() => true)
    .catch(error => {
      if (error.response && error.response.status === 404) {
        return false;
      }

      throw error;
    });
}

function pendingInvitationExists(invitationId) {
  const networkPendingInvitationExists = getPendingInvitationExistsRequest(NETWORK_INVITATION_API);
  const projectPendingInvitationExists = getPendingInvitationExistsRequest(PROJECT_INVITATION_API);
  return Promise.all([
    networkPendingInvitationExists(invitationId),
    projectPendingInvitationExists(invitationId)
  ])
    .then(([networkInvitationExists, projectInvitationExists]) => networkInvitationExists || projectInvitationExists);
}

function pendingOrAcceptedInvitationAsSubcontractorExists(country, registrationNumber, vatIdentificationNumber) {
  // The backend returns a 204 status code when such an invitation exists, and a 404 status code otherwise.
  const url = `${INVITATION_API}/subcontractor/exists` +
      `?country=${country}` +
      `&registrationNumber=${registrationNumber}` +
      `&vatIdentificationNumber=${vatIdentificationNumber}`;
  return authFetch(url)
    .then(checkStatus)
    .then(() => true)
    .catch(error => {
      if (error.response && (error.response.status === 404)) {
        return false;
      }

      throw error;
    });
}

export default {
  decodeToken,
  createAccessCode,
  downloadAccessCode,
  addSubcontractorViaAccessCode,
  inviteUser,
  pendingInvitationExists,
  pendingOrAcceptedInvitationAsSubcontractorExists
};
